 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"polyfills-core-js":"polyfills-core-js","polyfills-dom":"polyfills-dom","stencil-polyfills-css-shim":"stencil-polyfills-css-shim","stencil-polyfills-dom":"stencil-polyfills-dom"}[chunkId]||chunkId) + "." + {"chunk-008cd3d6":"7d4efbaa","chunk-02c995b5":"dfd515b6","chunk-09155df3":"40e9e828","chunk-09162720":"5daf8d1e","chunk-097e0872":"ba5fe3dd","chunk-0e93a01c":"ffcff66a","chunk-1646c354":"3584053c","chunk-2d0c09eb":"ce745066","chunk-2d213555":"9968a149","chunk-2d21b4ae":"48843315","chunk-2d2288f5":"b5b71acb","chunk-2d238a08":"eb836691","chunk-1dbc15a2":"75e40b7a","chunk-1f3fa45a":"d135d03c","chunk-21a76241":"1859374e","chunk-21f701ea":"c0dcebd5","chunk-25d83ca8":"81b08d8c","chunk-2d0a3ffc":"ae92ec73","chunk-2d0a463b":"8d43012a","chunk-2d0ac931":"17cfa0f8","chunk-2d0c073f":"51dd8b12","chunk-2d0c211b":"ba545cf5","chunk-2d0cf315":"1ef6206f","chunk-2d0d43da":"b017c710","chunk-2d0d6f0e":"80055871","chunk-2d0da04a":"219ce0c4","chunk-2d0e5812":"a4b8f3a4","chunk-2d208702":"36ed287c","chunk-2d213189":"4a1e81e6","chunk-2d217def":"b35cd03e","chunk-2d218068":"a3d18fba","chunk-2d21a9aa":"6003d65f","chunk-2d21da73":"3279dcbb","chunk-2d222cca":"2219326e","chunk-2d22895d":"ca2e81cc","chunk-2d2304d2":"2178b8d3","chunk-2d23721e":"db20ec86","chunk-30dd9750":"a2348730","chunk-34f7327c":"52a3b5f9","chunk-37a4480b":"dd8aa073","chunk-37f2300e":"b167a138","chunk-38a9692a":"39fc817b","chunk-38af18cf":"01cbfe60","chunk-390501b0":"0a73290d","chunk-3ed29de3":"e09218b3","chunk-3fc8272f":"d6764369","chunk-3fd85219":"6504de62","chunk-41c0f7a4":"ea1e2d66","chunk-462c869e":"f0e09ed2","chunk-504c4825":"4eefab68","chunk-51c84994":"b6bb7667","chunk-541ea42d":"0d2b1e35","chunk-54bbd082":"92855589","chunk-59d4c87c":"ab94b52e","chunk-5a8ac886":"8430e3d7","chunk-5ff96a24":"2f264265","chunk-620faf86":"ff7e9046","chunk-63b14724":"5c721742","chunk-0caee39a":"ecc03bbc","chunk-41da7c08":"dbf8ec33","chunk-754a5e92":"ea58f19a","chunk-7df9a91d":"0e09b244","chunk-69eb8776":"ffed9f83","chunk-6d375f34":"7d28fd51","chunk-71a2bef0":"e734f32a","chunk-7548ca2d":"c9b8069e","chunk-79f1dac7":"06662d1e","chunk-79f513a2":"005922ea","chunk-7b288caf":"0d51372e","chunk-751cde7c":"c0ef4818","chunk-ba442204":"5bfec729","chunk-c7bc7e96":"c843115c","chunk-f2ddd5de":"00ebdaec","chunk-f5cc7fd0":"6a56dbae","chunk-137a3a94":"22f231a3","chunk-814c42de":"e349f45a","chunk-858cd918":"3d27d137","chunk-86aefdd8":"bc36b735","chunk-89b92314":"82883cab","chunk-8bb7f81e":"6794ad2b","chunk-978ee2a6":"355cc458","chunk-a9395c36":"72023757","chunk-a971ef6a":"29ade1a8","chunk-6065fac8":"0cd77cb6","chunk-628d54bb":"30f1c5f3","chunk-df0c6576":"a1596a82","chunk-bf0136e0":"238cbbab","chunk-c53d26f0":"461c63d2","chunk-c567cc2a":"f44305ea","chunk-d029f82c":"887b25cb","chunk-d0e8aa0a":"8e60b6b2","chunk-d59bc17c":"620841e3","chunk-d6bd7750":"14e83afc","chunk-d8413eac":"3e1c1dd6","chunk-eaa2b130":"f3b25d12","chunk-1e497f4e":"9c5130da","chunk-26eea06a":"391e7101","chunk-f858ef4e":"ffd7a8c3","polyfills-core-js":"8da452c8","polyfills-dom":"5c1a31ff","stencil-polyfills-css-shim":"54fc0886","stencil-polyfills-dom":"a351dbf1","chunk-2d0b62ff":"f98ff668","chunk-2d0b33e3":"64be60e2","chunk-2d0bd1c8":"af3dd47d","chunk-2d0c1ca1":"a8741f4e","chunk-2d0e19fd":"55dbdcb5","chunk-2d209619":"2be46e60","chunk-2d2376e6":"a351546d"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"chunk-1646c354":1,"chunk-21f701ea":1,"chunk-37a4480b":1,"chunk-38a9692a":1,"chunk-38af18cf":1,"chunk-390501b0":1,"chunk-3fc8272f":1,"chunk-3fd85219":1,"chunk-51c84994":1,"chunk-620faf86":1,"chunk-63b14724":1,"chunk-0caee39a":1,"chunk-41da7c08":1,"chunk-754a5e92":1,"chunk-7df9a91d":1,"chunk-71a2bef0":1,"chunk-79f513a2":1,"chunk-751cde7c":1,"chunk-ba442204":1,"chunk-c7bc7e96":1,"chunk-f2ddd5de":1,"chunk-f5cc7fd0":1,"chunk-137a3a94":1,"chunk-814c42de":1,"chunk-86aefdd8":1,"chunk-89b92314":1,"chunk-978ee2a6":1,"chunk-a971ef6a":1,"chunk-6065fac8":1,"chunk-628d54bb":1,"chunk-df0c6576":1,"chunk-bf0136e0":1,"chunk-d029f82c":1,"chunk-d59bc17c":1,"chunk-d6bd7750":1,"chunk-1e497f4e":1,"chunk-26eea06a":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"polyfills-core-js":"polyfills-core-js","polyfills-dom":"polyfills-dom","stencil-polyfills-css-shim":"stencil-polyfills-css-shim","stencil-polyfills-dom":"stencil-polyfills-dom"}[chunkId]||chunkId) + "." + {"chunk-008cd3d6":"31d6cfe0","chunk-02c995b5":"31d6cfe0","chunk-09155df3":"31d6cfe0","chunk-09162720":"31d6cfe0","chunk-097e0872":"31d6cfe0","chunk-0e93a01c":"31d6cfe0","chunk-1646c354":"382fad28","chunk-2d0c09eb":"31d6cfe0","chunk-2d213555":"31d6cfe0","chunk-2d21b4ae":"31d6cfe0","chunk-2d2288f5":"31d6cfe0","chunk-2d238a08":"31d6cfe0","chunk-1dbc15a2":"31d6cfe0","chunk-1f3fa45a":"31d6cfe0","chunk-21a76241":"31d6cfe0","chunk-21f701ea":"1871e825","chunk-25d83ca8":"31d6cfe0","chunk-2d0a3ffc":"31d6cfe0","chunk-2d0a463b":"31d6cfe0","chunk-2d0ac931":"31d6cfe0","chunk-2d0c073f":"31d6cfe0","chunk-2d0c211b":"31d6cfe0","chunk-2d0cf315":"31d6cfe0","chunk-2d0d43da":"31d6cfe0","chunk-2d0d6f0e":"31d6cfe0","chunk-2d0da04a":"31d6cfe0","chunk-2d0e5812":"31d6cfe0","chunk-2d208702":"31d6cfe0","chunk-2d213189":"31d6cfe0","chunk-2d217def":"31d6cfe0","chunk-2d218068":"31d6cfe0","chunk-2d21a9aa":"31d6cfe0","chunk-2d21da73":"31d6cfe0","chunk-2d222cca":"31d6cfe0","chunk-2d22895d":"31d6cfe0","chunk-2d2304d2":"31d6cfe0","chunk-2d23721e":"31d6cfe0","chunk-30dd9750":"31d6cfe0","chunk-34f7327c":"31d6cfe0","chunk-37a4480b":"d8cbeaec","chunk-37f2300e":"31d6cfe0","chunk-38a9692a":"485bbdc1","chunk-38af18cf":"1871e825","chunk-390501b0":"1871e825","chunk-3ed29de3":"31d6cfe0","chunk-3fc8272f":"4cc2bd31","chunk-3fd85219":"3e83196d","chunk-41c0f7a4":"31d6cfe0","chunk-462c869e":"31d6cfe0","chunk-504c4825":"31d6cfe0","chunk-51c84994":"6776488d","chunk-541ea42d":"31d6cfe0","chunk-54bbd082":"31d6cfe0","chunk-59d4c87c":"31d6cfe0","chunk-5a8ac886":"31d6cfe0","chunk-5ff96a24":"31d6cfe0","chunk-620faf86":"cd7a17ab","chunk-63b14724":"1e70702b","chunk-0caee39a":"f61ca6fc","chunk-41da7c08":"5f14ca3a","chunk-754a5e92":"28f3fe16","chunk-7df9a91d":"5f14ca3a","chunk-69eb8776":"31d6cfe0","chunk-6d375f34":"31d6cfe0","chunk-71a2bef0":"1871e825","chunk-7548ca2d":"31d6cfe0","chunk-79f1dac7":"31d6cfe0","chunk-79f513a2":"0d83bad3","chunk-7b288caf":"31d6cfe0","chunk-751cde7c":"d08059bb","chunk-ba442204":"a8c7c442","chunk-c7bc7e96":"77bea9ab","chunk-f2ddd5de":"5f62aa7b","chunk-f5cc7fd0":"5c28da32","chunk-137a3a94":"d3c8575d","chunk-814c42de":"12211f08","chunk-858cd918":"31d6cfe0","chunk-86aefdd8":"0d83bad3","chunk-89b92314":"eb9bb029","chunk-8bb7f81e":"31d6cfe0","chunk-978ee2a6":"fb2bc4bf","chunk-a9395c36":"31d6cfe0","chunk-a971ef6a":"bae58f10","chunk-6065fac8":"c6b3117f","chunk-628d54bb":"60e46ec9","chunk-df0c6576":"911ab442","chunk-bf0136e0":"3e83196d","chunk-c53d26f0":"31d6cfe0","chunk-c567cc2a":"31d6cfe0","chunk-d029f82c":"3e83196d","chunk-d0e8aa0a":"31d6cfe0","chunk-d59bc17c":"5d87103f","chunk-d6bd7750":"626e96d7","chunk-d8413eac":"31d6cfe0","chunk-eaa2b130":"31d6cfe0","chunk-1e497f4e":"919597e3","chunk-26eea06a":"b77b8997","chunk-f858ef4e":"31d6cfe0","polyfills-core-js":"31d6cfe0","polyfills-dom":"31d6cfe0","stencil-polyfills-css-shim":"31d6cfe0","stencil-polyfills-dom":"31d6cfe0","chunk-2d0b62ff":"31d6cfe0","chunk-2d0b33e3":"31d6cfe0","chunk-2d0bd1c8":"31d6cfe0","chunk-2d0c1ca1":"31d6cfe0","chunk-2d0e19fd":"31d6cfe0","chunk-2d209619":"31d6cfe0","chunk-2d2376e6":"31d6cfe0"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
